export const homePagePath = '/';
export const jobsPath = '/jobs';
export const jobBacklogPath = '/job-backlog';
export const fileBacklogPath = '/file-backlog';
export const measureDataPath = '/measure';
export const transactionsPath = '/transactions';
export const transactionStatisticsPath = '/transaction-statistics';
export const logoutPath = '/logout';
